import { render, staticRenderFns } from "./service-dish-list.vue?vue&type=template&id=08d2e536&scoped=true"
import script from "./service-dish-list.vue?vue&type=script&lang=js"
export * from "./service-dish-list.vue?vue&type=script&lang=js"
import style0 from "./service-dish-list.vue?vue&type=style&index=0&id=08d2e536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2e536",
  null
  
)

export default component.exports